import { useTranslation } from 'react-i18next';
import { BodyTypeValue, BodyTypeMessages } from 'lib/bodyType';
// assets
import { colors, screen } from 'components/styles/variables';
import bodyTypeSprite from 'public/static/images/body-type-sprite-lg.png';
import convertible from 'public/static/images/body_styles/convertible.jpg';
import coupe from 'public/static/images/body_styles/coupe.jpg';
import minivan from 'public/static/images/body_styles/minivan.jpg';
import sedan from 'public/static/images/body_styles/sedan.jpg';
import suv from 'public/static/images/body_styles/suv.jpg';
import truck from 'public/static/images/body_styles/truck.jpg';
import wagon from 'public/static/images/body_styles/wagon.jpg';
import crossOver from 'public/static/images/body_styles/crossover.jpg';

interface BodyTypeMenuProps {
  onSelect: (bodyType: string) => void;
}

interface ListItemProps {
  bodyTypeMessage: string;
  bodyType: string;
  onClick: () => void;
}

const bodyTypes = [
  BodyTypeValue.Convertible,
  BodyTypeValue.Coupe,
  BodyTypeValue.Hatchback,
  BodyTypeValue.Minivan,
  BodyTypeValue.Sedan,
  BodyTypeValue.SUV,
  BodyTypeValue.Truck,
  BodyTypeValue.Wagon,
];

function BodyTypeMenu({ onSelect }: BodyTypeMenuProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div data-body-type-menu>
      <div className="header">
        <span>{t('bodyStyleSearch.header')}</span>
      </div>
      <div className="body">
        <ul className="body-types-list">
          {bodyTypes.map((bodyType) => (
            <ListItem
              key={bodyType}
              bodyTypeMessage={BodyTypeMessages[bodyType]}
              bodyType={bodyType}
              onClick={(): void => onSelect(bodyType)}
            />
          ))}
        </ul>
      </div>
      <style jsx>
        {`
          .header {
            padding: 17px 10px 10px 14px;
            border-bottom: 1px solid ${colors.G2};
            height: 60px;
            font-weight: 600;
            color: ${colors.BLACK};
            background-color: white;
            border-radius: 5px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            text-align: center;
            text-transform: capitalize;
          }

          .body-types-list {
            list-style: none;
            margin: 0;
            margin-top: 8px;
            padding: 0 0 20px 0;
          }

          .body {
            padding: 0px 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: white;
          }

          @media (min-width: ${screen.smMin}) {
            .header {
              position: relative;
            }
          }
        `}
      </style>
    </div>
  );
}

function ListItem({ bodyTypeMessage, bodyType, onClick }: ListItemProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <li className="body-type-menu-list-item">
      <button
        data-body-type-menu-item={bodyType}
        className={`body-type-menu-button ${bodyType}`}
        onClick={onClick}
      >
        <div className="icon" />
        <div className="body-type-label">{t(bodyTypeMessage)}</div>
      </button>
      <style jsx>
        {`
          .body-type-menu-list-item {
            color: ${colors.G4};
            display: inline-block;
            text-align: center;
            width: 50%;
            height: 137px;
          }

          .body-type-menu-button {
            border: solid 1px transparent;
            background-color: white;
            cursor: pointer;
          }

          .body-type-menu-button:focus {
            border: solid 1px ${colors.G2};
            border-radius: 8px;
          }

          .icon {
            background-image: url(${bodyTypeSprite});
            width: 100px;
            height: 40px;
            margin: 20px auto 0 auto;
          }

          .sedan .icon {
            width: 132px;
            height: 78px;
            background-position: 0% 50%;
            background-image: url(${sedan});
            background-size: cover;
          }

          .truck .icon {
            width: 132px;
            height: 78px;
            background-position: 0% 50%;
            background-image: url(${truck});
            background-size: cover;
          }

          .convertible .icon {
            width: 132px;
            height: 78px;
            background-position: 0% 50%;
            background-image: url(${convertible});
            background-size: cover;
          }

          .minivan .icon {
            width: 132px;
            height: 78px;
            background-position: 0% 50%;
            background-image: url(${minivan});
            background-size: cover;
          }

          .coupe .icon {
            width: 132px;
            height: 78px;
            background-position: 0% 50%;
            background-image: url(${coupe});
            background-size: cover;
          }

          .suv .icon {
            width: 132px;
            height: 78px;
            background-position: 0% 50%;
            background-image: url(${suv});
            background-size: cover;
          }

          .wagon .icon {
            width: 132px;
            height: 78px;
            background-position: 0% 50%;
            background-image: url(${wagon});
            background-size: cover;
          }

          .hatchback .icon {
            width: 132px;
            height: 78px;
            background-position: 0% 50%;
            background-image: url(${crossOver});
            background-size: cover;
          }

          .body-type-label {
            font-size: 17px;
            font-weight: 100;
            color: ${colors.BLACK};
            text-align: center;
            height: 25px;
            margin-top: 10px;
          }
        `}
      </style>
    </li>
  );
}

export default BodyTypeMenu;
